/* =========================================================================
   Multi-open accordion
   SCOPED STRICTLY to `.accordion-wrapper .accordion` (product info accordion).
   Does NOT touch any other accordion/toggle on the site.

   - Allows multiple panels open at once (no auto-collapse -> no page jump).
   - All panels start closed on load (initial state comes from the markup's
     aria-expanded="false"; the theme's single-open handler is neutralised).
   - Uses a capture-phase listener + stopImmediatePropagation to neutralise
     the theme's existing single-open handler (which we could not locate in
     the theme assets), whether it is bound directly or delegated.
   ========================================================================= */
(function () {
  function initAccordion(accordion) {
    if (accordion.dataset.multiOpenInit === 'true') return;
    accordion.dataset.multiOpenInit = 'true';

    accordion.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest('button');
        if (!btn) return;

        // Only handle the top-level toggle buttons of THIS accordion:
        // structure is `.accordion > .accordion-item > button`.
        var item = btn.closest('.accordion-item');
        if (!item || item.parentElement !== accordion) return;

        // Block the theme's single-open handler and run our own toggle.
        e.preventDefault();
        e.stopImmediatePropagation();

        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      },
      true // capture phase
    );
  }

  function init() {
    var accordions = document.querySelectorAll('.accordion-wrapper .accordion');
    accordions.forEach(function (accordion) {
      initAccordion(accordion);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
